import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon/Icon';
import type { MessageProps } from './Message.types';
import './message.scss';

const Message = ({ avatar, name, time, message, position, typing }: MessageProps) => {
  const send = position === 'left' ? '' : 'sb-message__received';
  const type = typing ? 'sb-message__typing' : '';

  return (
    <div
      className={['sb-message',
        send,
        type
      ].join(' ')}
      data-testid="sb-message"
    >
      <img
        className="sb-message__image"
        data-testid="sb-message__image"
        src={avatar}
        alt={name}
      />
      <div
        className="sb-message__container"
        data-testid="sb-message__container"
      >
        {!typing &&
          <p
            className="sb-message__container--text"
            data-testid="sb-message__container--text"
          >
            {name}, {time}
          </p>
        }
        <div
          className="sb-message__message"
          data-testid="sb-message__message"
        >
          {typing ?
            <Icon
              iconName="more-horizontal"
              size={30}
              className=""
            /> :
            message
          }
        </div>
      </div>
    </div>
  );
};

Message.propTypes = {
  /**
 * avatar
 */
  avatar: PropTypes.string,
  /**
* name
*/
  name: PropTypes.string,
  /**
* time
*/
  time: PropTypes.string,
  /**
* message
*/
  message: PropTypes.string,
  /**
   * left or right
   */
  position: PropTypes.oneOf(['right', 'left']),
  /**
* typing
*/
  typing: PropTypes.bool,
};

Message.defaultProps = {
  avatar: "https://i.ibb.co/QKkpfgc/user-image-2.png",
  name: "Maria Rodríguez",
  time: "22:10 PM",
  message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer libero felis, tincidunt quis lectus ut, tincidunt pharetra massa. In sed dapibus tellus, vel semper odio. Maecenas aliquet fermentum dolor, vitae ",
  position: "left",
  typing: false,
};

export default Message;